import React from "react";
import { I } from "./icons";
import InfoBadge from "./InfoBadge";

export const Card = ({ children, className = "", style }) => (
  <div className={`cd ${className}`} style={style}>{children}</div>
);

export const CardHead = ({ icon: Ico, title, right, info }) => (
  <div className="cd-head">
    <div className="cd-title">
      {Ico ? <Ico size={16} /> : null}
      <span>{title}</span>
    </div>
    {(right || info) ? (
      <div className="cd-meta">
        {right}
        {info ? <InfoBadge info={info} /> : null}
      </div>
    ) : null}
  </div>
);

export const CardBody = ({ children, style }) => <div className="cd-body" style={style}>{children}</div>;
export const CardFoot = ({ children }) => <div className="cd-foot">{children}</div>;

/* KPI Card — tier: 'hero' | 'primary' | 'secondary' | 'compact'
   tone: 'primary' | 'cyan' | 'success' | 'warning' | 'danger' */
export const KPI = ({
  tier = "primary", tone = "primary", icon: Ico,
  label, value, delta, deltaTone = "pos", deltaRef,
  extras, info,
}) => {
  const cls = `cd kpi ${tier === "hero" ? "hero" : tier === "secondary" ? "secondary" : tier === "compact" ? "compact" : ""}`;
  const card = (
    <div className={cls}>
      <div className="kpi-row">
        <span className="kpi-label">{label}</span>
        {Ico ? <span className={`kpi-tile ${tone}`}><Ico size={tier === "compact" ? 16 : 22} /></span> : null}
      </div>
      <div className="kpi-value">{value}</div>
      {delta ? (
        <div className="kpi-delta">
          <span className={`kpi-pill ${deltaTone}`}>{delta}</span>
          {deltaRef ? <span className="kpi-ref">{deltaRef}</span> : null}
        </div>
      ) : deltaRef ? (
        <div className="kpi-delta">
          <span className="kpi-ref">{deltaRef}</span>
        </div>
      ) : null}
      {extras ? <div className="kpi-delta">{extras}</div> : null}
    </div>
  );
  if (!info) return card;
  return (
    <div className="kpi-wrap">
      {card}
      <InfoBadge info={info} placement="absolute" />
    </div>
  );
};

export const CompactKPI = ({ tone = "primary", icon: Ico, label, value, prev, delta, deltaTone = "pos", info }) => {
  const card = (
    <div className="cd kpi compact">
      <div className="kpi-row">
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span className={`kpi-tile ${tone}`}><Ico size={16} /></span>
          <span className="kpi-label">{label}</span>
        </div>
        {delta ? <span className={`kpi-pill ${deltaTone}`}>{delta}</span> : null}
      </div>
      <div className="kpi-value">{value}</div>
      {prev ? <span className="kpi-ant">Anterior: {prev}</span> : null}
    </div>
  );
  if (!info) return card;
  return (
    <div className="kpi-wrap">
      {card}
      <InfoBadge info={info} placement="absolute" />
    </div>
  );
};

export const ChartCard = ({ icon, title, meta, legend, foot, children, bodyStyle, info }) => (
  <Card>
    <CardHead icon={icon} title={title} right={meta} info={info} />
    {legend ? <div className="cd-body" style={{ paddingTop: 0, paddingBottom: 0 }}>{legend}</div> : null}
    <CardBody style={bodyStyle}>{children}</CardBody>
    {foot ? <CardFoot>{foot}</CardFoot> : null}
  </Card>
);

export const Badge = ({ tone = "neu", children, icon: Ico }) => (
  <span className={`bdg ${tone}`}>
    {Ico ? <Ico size={11} /> : <span className="dot" />}
    {children}
  </span>
);

export const BankChip = ({ bank }) => {
  const key = (bank || "").toUpperCase();
  const variants = { BBVA: "bbva", CAIXABANK: "caixa", REVOLUT: "revolut" };
  return (
    <span className={`bank-chip ${variants[key] || ""}`}>
      <span className="dot" />
      {bank}
    </span>
  );
};

export const Delta = ({ value, kind = "pos", suffix }) => (
  <span className="kpi-delta">
    <span className={`kpi-pill ${kind}`}>{kind === "pos" ? "↑" : "↓"} {value}</span>
    {suffix ? <span className="kpi-ref">{suffix}</span> : null}
  </span>
);

export const Legend = ({ items }) => (
  <div className="legend">
    {items.map((it, i) => (
      <span className="lg" key={i}>
        {it.dashed
          ? <span className="dash" style={{ borderTopColor: it.color }} />
          : <span className="d" style={{ background: it.color }} />}
        {it.label}
      </span>
    ))}
  </div>
);

export const Alert = ({ tone = "info", icon: Ico, title, sub, action }) => (
  <div className={`alert ${tone}`}>
    {Ico ? <Ico size={18} /> : null}
    <div className="body">
      <div className="txt">{title}</div>
      {sub ? <div className="sub">{sub}</div> : null}
    </div>
    {action}
  </div>
);

export const Empty = ({ icon: Ico, title, sub, ok }) => (
  <div className={`empty ${ok ? "ok" : ""}`}>
    {Ico ? <Ico size={28} /> : null}
    <div className="t">{title}</div>
    {sub ? <div className="s">{sub}</div> : null}
  </div>
);
